import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface RouteTransitionContextValue {
  isTransitioning: boolean;
}

const RouteTransitionContext = createContext<RouteTransitionContextValue>({
  isTransitioning: false,
});

export const useRouteTransition = () => useContext(RouteTransitionContext);

export const RouteTransitionProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    // Set transitioning to true when route changes
    setIsTransitioning(true);

    // Clear transitioning flag after animation completes (max 500ms)
    const timeout = setTimeout(() => {
      setIsTransitioning(false);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [location.pathname]);

  return (
    <RouteTransitionContext.Provider value={{ isTransitioning }}>
      {children}
    </RouteTransitionContext.Provider>
  );
};
